import {all} from 'redux-saga/effects'
import {combineReducers} from 'redux'

import * as auth from '../../app/modules/auth'
import { DashboardSlice } from "../../app/pages/dashboard/_redux/dashboard/Slice";


export const rootReducer = combineReducers({
  auth: auth.reducer,
  dashboard: DashboardSlice.reducer
})

export type RootState = ReturnType<typeof rootReducer>

export function* rootSaga() {
  yield all([auth.saga()])
}
